import { format } from 'date-fns';
import { ForecastMeasurementType } from '../components/forecast/ForecastLineChart';

export const mockParsedCuidList: ParsedCuidList = {
  FAM178083: {
    cuid: 'FAM178083',
    cuidName: 'GS 풍력발전',
    derResType: 'individual',
    sites: [{ siteId: 'y1', siteName: 'test' }],
  },
};

export const mockCuidList = [
  {
    cuid: 'FAM178083',
    cuidName: 'GS풍력발전',
    derResType: 'individual',
    siteId: 'y1',
    siteName: 'GS영양풍력',
  },
];

export const mockForecastHourly = [
  {
    optime_valid_second: 1,
    power_pred_first: 65462.525,
    power_pred_avg: 32056.667,
    err_avg: 5.134,
    income: 273610.344,
    err_second: 6.749,
    unit_price: 4,
    avail_second: 75.122,
    cuid_profile: {
      company_id: 'GSWP',
      cuid_name: 'GS풍력발전',
      cuid: 'FAM178083',
    },
    optime_valid_first: 1,
    power_metered: 68402.586,
    err_first: 3.519,
    ym: '2024-12',
    avail_first: 78.351,
    avail_metered: 81.87,
    sk: '2024-12-01 01:00:00',
    pk: 'FAM178083',
    power_pred_second: 62764.143,
  },
];

export const testTableData = [
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-02 20:00',
    note: 'Scheduled maintenance',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
  {
    date: '2024-12-01 08:00-2024-12-02 18:00',
    capacity: '100.00 MW',
    utilization: '90',
    target: '1호기',
    lastUpdated: '2024-12-04 18:00',
    note: 'Unexpected breakdown',
  },
];

export const testCustomerSiteData = {
  status: 'success',
  gen_num: 25,
  capacity_total_mwh: 76.2,
  capacity_gen_mwh: 59.4,
  capacity_ess_mwh: 16.8,
  del_dt: null,
  plants: ['4719', '8733'],
  has_ess: true,
  cuid: 'FAM178083',
  reg_dt: '2025-02-06 18:10:30',
  cuid_name: 'GS풍력발전',
  longitude: 129.215,
  sk: 'y1',
  pk: 'COMP#GSWP',
  latitude: 36.614,
};

export const capacityTotalMwh = '100000';

export const testLimitData = [
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
  {
    startTime: '2025-02-01 11:30:00',
    utilRate_site: '30',
    active: true,
    endTime: '2025-02-10 22:30:00',
    memo: '메모입니다',
    pk: 'y1',
    utilRate_generator_003: '30',
    utilRate_generator_002: '20',
    utilRate_generator_001: '10',
  },
];

export const dataGenerator = (
  startDate: Date,
  endDate: Date,
  yLimit: number = 100,
  count: number = 6
) => {
  const startTime = startDate.getTime();
  const endTime = endDate.getTime();
  const uniqueTimes = new Set<number>();

  return Array.from({ length: count }, () => {
    let randomTime;

    do {
      randomTime = startTime + Math.random() * (endTime - startTime);
    } while (uniqueTimes.has(randomTime));

    uniqueTimes.add(randomTime);
    return {
      name: format(new Date(randomTime), 'yyyy.MM.dd HH:mm:ss'),
      [ForecastMeasurementType.FirstPrediction]: Math.random() * yLimit,
    };
  });
};

export const testAccountTableData = [
  {
    sub: '0438cd2c-a0a1-707c-f86d-fd9eeb2591f7',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'juhyunlee@gsenergy.co.kr',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'user',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'user',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
  {
    sub: '',
    name: 'test user',
    company: 'GS ENERGY',
    department: 'GSE DITeam',
    email: 'sm.choi@gsenergy.in',
    contact: '010-0000-0000',
    role: 'admin',
    lastLogin: '2024.12.01 12:00',
    lastIP: '112.220.21.66',
    createDate: '2024.12.01',
  },
];

export const testSettlementTableData = [
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
  {
    resourceName: 'GS 동해전력 집합자원',
    generatorName: '(주)하이돈 푸드시스템 태양광 발전소',
    contracteeType: '집합',
    earnings: '2,445,550 원',
    totalGeneration: '16,968 MWh',
    generationRatio: '20.4 %',
    resourceSettlement: '1,000,000',
    plantIncentive: '1,000,000',
    currentStatus: 1,
  },
];

export const testManagementGenerationListTable = [
  {
    resourceName: 'GS동해전력_집합자원',
    resourceCode: 'FGSDEP001',
    plantName: '고운태양광에너지',
    plantType: '태양광',
    energyMarketId: '6994',
    generationCapacity: '988',
    plantId: 'aa0000',
    generatorCount: '0000',
    generatorCapacity: '9999',
    coordinates: '36.7396600, 126.2751000',
    location: '전남 고흥 두원면',
  },
  {
    resourceName: 'GS동해전력_집합자원',
    resourceCode: 'FGSDEP001',
    plantName: '고운태양광에너지',
    plantType: '태양광',
    energyMarketId: '6994',
    generationCapacity: '988',
    plantId: 'aa0000',
    generatorCount: '0000',
    generatorCapacity: '9999',
    coordinates: '36.7396600, 126.2751000',
    location: '전남 고흥 두원면',
  },
];

export const testManagementResourceListTable = [
  {
    resourceName: 'GS동해전력_집합자원',
    resourceCode: 'FGSDEP001',
    generatorCapacity: '89.7',
    virtualPowerPlantCode: 'FGSDE9999',
    memberCompanyName: 'GRIDUS',
    associatedPowerPlant: '23',
  },
  {
    resourceName: 'GS동해력_집합자원',
    resourceCode: 'FGSDEP001',
    generatorCapacity: '89.7',
    virtualPowerPlantCode: 'FGSDE9999',
    memberCompanyName: 'GRIDUS',
    associatedPowerPlant: '23',
  },
  {
    resourceName: 'GS동전력_집합자원',
    resourceCode: 'FGSDEP001',
    generatorCapacity: '89.7',
    virtualPowerPlantCode: 'FGSDE9999',
    memberCompanyName: 'GRIDUS',
    associatedPowerPlant: '23',
  },
  {
    resourceName: 'GS동해전_집합자원',
    resourceCode: 'FGSDEP001',
    generatorCapacity: '89.7',
    virtualPowerPlantCode: 'FGSDE9999',
    memberCompanyName: 'GRIDUS',
    associatedPowerPlant: '23',
  },
  {
    resourceName: 'GS동해전력_집합자원',
    resourceCode: 'FGSDEP001',
    generatorCapacity: '89.7',
    virtualPowerPlantCode: 'FGSDE9999',
    memberCompanyName: 'GRIDUS',
    associatedPowerPlant: '23',
  },
  {
    resourceName: 'GS동해전력_집합자원',
    resourceCode: 'FGSDEP001',
    generatorCapacity: '89.7',
    virtualPowerPlantCode: 'FGSDE9999',
    memberCompanyName: 'GRIDUS',
    associatedPowerPlant: '23',
  },
  {
    resourceName: 'GS동해전력_집합자원',
    resourceCode: 'FGSDEP001',
    generatorCapacity: '89.7',
    virtualPowerPlantCode: 'FGSDE9999',
    memberCompanyName: 'GRIDUS',
    associatedPowerPlant: '23',
  },
];

export const testSettlementSummaryCardData = [
  {
    field: '예측자원 전체 발전량',
    value: '1,903,802',
    unit: 'MWh',
  },
  {
    field: '전체 발전량 대비 기여도',
    value: '4.83',
    unit: '%',
  },
  {
    field: '발전량',
    value: '91,889',
    unit: ' MWh',
  },
];

export const testIndividualResourceInvoiceData = [
  {
    siteName: '발전소1',
    siteCapacity: 10,
    siteGenerationMwh: 100,
    siteIncentive: 1000,
  },
  {
    siteName: '발전소2',
    siteCapacity: 20,
    siteGenerationMwh: 200,
    siteIncentive: 2000,
  },
  {
    siteName: '발전소3',
    siteCapacity: 30,
    siteGenerationMwh: 300,
    siteIncentive: 3000,
  },
];

export const testSetResoureInvoiceData = [
  {
    cuidName: '집합자원1',
    siteName: '발전소1',
    capacity: 10,
    generationMwh: 100,
    generationRatio: 10,
    settlementCuid: 1000000,
    distributionRatio: 10,
    siteIncentive: 10,
    invoiceStatus: '정산서 발행완료',
  },
  {
    cuidName: '집합자원1',
    siteName: '발전소2',
    capacity: 20,
    generationMwh: 200,
    generationRatio: 20,
    settlementCuid: 2000000,
    distributionRatio: 20,
    siteIncentive: 20,
    invoiceStatus: '정산서 발행완료',
  },
  {
    cuidName: '집합자원2',
    siteName: '발전소3',
    capacity: 30,
    generationMwh: 300,
    generationRatio: 30,
    settlementCuid: 3000000,
    distributionRatio: 30,
    siteIncentive: 30,
    invoiceStatus: '정산서 발행완료',
  },
];
